import React from 'react';

import UDText from 'ud-ui/components/text';
import { TooltipPosition, TooltipProps, TooltipWrapper } from 'ud-ui/components/tippy';

interface UDSectionTitleProps extends TooltipProps {
  title: string;
  icon?: string;
  className?: string;
}

const UDSectionTitle: React.FC<UDSectionTitleProps> = ({ title, icon = '', className = 'mb-4', tooltip, tooltipProps }) => {
  const tooltipPosition = tooltipProps?.position || 'right';

  const renderTooltip = (position: TooltipPosition) => (
    <TooltipWrapper tooltip={tooltip} tooltipProps={{ ...tooltipProps, position }} position={position} />
  );

  return (
    <div className={`flex items-center ${className}`}>
      {tooltipPosition === 'left' && renderTooltip('left')}
      <UDText type="callout">
        {icon} {title}
      </UDText>
      {tooltipPosition === 'right' && renderTooltip('right')}
    </div>
  );
};

export default UDSectionTitle;
